import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// eslint-disable-next-line react-refresh/only-export-components
export function initSentry() {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN || "",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: import.meta.env.VITE_ENV || "production",
    });
  }
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;

// Error fallback component
export const ErrorFallback = ({ error }: { error?: Error }) => {
  return (
    <div
      role="alert"
      style={{
        padding: "20px",
        margin: "20px",
        border: "1px solid var(--brand-secondary)",
        borderRadius: "8px",
        backgroundColor: "var(--background)",
      }}
    >
      <h2 style={{ color: "var(--brand-secondary)" }}>
        エラーが発生しました / An error occurred
      </h2>
      <p>申し訳ございません。予期しないエラーが発生しました。</p>
      <p>We&apos;re sorry, an unexpected error occurred.</p>
      {error && (
        <details style={{ marginTop: "10px" }}>
          <summary>Error details</summary>
          <pre style={{ fontSize: "12px", marginTop: "10px" }}>
            {error.message}
          </pre>
        </details>
      )}
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "var(--brand-secondary)",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        ページを再読み込み / Reload Page
      </button>
    </div>
  );
};
